export default __webpack_public_path__ + "dbc485d167749d38de5e8f69af159c99.svg";